import { useCallback, useState } from 'react';
import { mutate } from 'swr';
import {
  getApprovalTypeTemplateUrl,
  getApprovalTypeUrl,
} from '@/constant/approval';
import { putDataFetcher } from '@/utils/apis';

/**
 * 양식 작성 본문 템플릿 저장(어드민) mutation.
 * - PUT /api/v2/control/approval/type/{code}/template → 204
 *   403 해당 유형 관리 권한 없음(admin 역할만으론 부족) / 404 없는 유형 코드
 * - 성공 시 양식 메타(`useApprovalType`) 캐시 재검증 — 같은 세션 재진입 시 옛 템플릿 hydrate 방지.
 *   재검증 실패는 저장 성공 판정에 영향 없음
 * - 에러 토스트는 호출부 책임 — error 를 그대로 throw
 */
const useSaveApprovalTypeTemplate = () => {
  const [isSaving, setIsSaving] = useState(false);

  const saveTemplate = useCallback(
    async (code: number, contentTemplate: string | null): Promise<void> => {
      setIsSaving(true);
      try {
        await putDataFetcher(getApprovalTypeTemplateUrl(code), {
          contentTemplate,
        });
        await mutate(getApprovalTypeUrl(code)).catch(() => undefined);
      } finally {
        setIsSaving(false);
      }
    },
    [],
  );

  return { saveTemplate, isSaving };
};

export default useSaveApprovalTypeTemplate;
